import { BillingComp } from '@baidu/ad-comps';
export default {
  components: {
    BillingComp
  },
  props: {
    adInfo: {
      // 获取的广告数据
      type: Object,
      default: () => ({})
    },
    adAspectRatio: Number,
    // 广告图片宽高比
    adCoreUtils: Object // new AdCore拿到的js sdk实例
  },

  data() {
    return {
      isClose: false,
      // 是否关闭广告
      isAnimationEnd: false,
      // 关闭广告动画是否执行结束
      cardInfo: {
        // 广告计费组件所需广告卡信息
        resource_id: 'push_page'
      }
    };
  },
  computed: {
    // 是否展示广告
    isShowAd() {
      const {
        img_url = ''
      } = this.adInfo || {};
      // 图片存在 & 未关闭广告
      return img_url && !this.isAnimationEnd;
    },
    // 广告跳转按钮文字
    adJumpText() {
      const {
        jump_text = ''
      } = this.adInfo || {};
      if (!jump_text || jump_text.length > 4) {
        return '立即查看';
      }
      return jump_text;
    },
    // 是否为竖版图片
    isVerticalImage() {
      return this.adAspectRatio < 1;
    }
  },
  methods: {
    // 文案超出部分打点
    textOmit(str, len) {
      if (!str) {
        return '';
      }
      return str.length > len ? `${str.substring(0, len)}...` : str;
    },
    // 关闭广告
    closeAd() {
      this.isClose = true;
    },
    // 关闭动画执行结束
    handleAnimationEnd() {
      this.isAnimationEnd = true;
    }
  }
};